import axios from 'axios';

const homeAndAutoAPI = axios.create({
  baseURL: '/home-and-auto',
  headers: {
    'Content-Type': 'application/json',
  },
});

export default homeAndAutoAPI;
